import { useQueryClient } from 'react-query';
import { API } from '@vfit/shared/data-access';
import { IAllDataCMS, ICMSConfigPage } from './cms.models';

export const GRANDIAZIENDE_CMS_DEFAULT: ICMSConfigPage = {
  apis: [
    {
      key: 'getPageNavigation',
      api: API.CMS_GET_PAGE_GRANDIAZIENDE_NAVIGATION,
    },
    {
      key: 'getGenericError',
      api: API.CMS_GET_GENERIC_ERROR,
    },
    {
      key: 'getPages',
      api: API.CMS_GET_PAGES_GRANDIAZIENDE,
    },
    {
      key: 'getAllLeads',
      api: API.CMS_GET_ALL_LEADS,
    },
  ],
};

export const useCmsConfig = (page: ICMSConfigPage, apiKey?: string): IAllDataCMS => {
  const { apis } = page;
  const allData = {};
  apis?.forEach((api) => {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const client = useQueryClient();
    const data = client.getQueryData(api.key, { exact: false });
    allData[api.api] = data;
  });
  return apiKey ? allData[apiKey] : allData;
};
